<template>
  <v-layout wrap class="wrappColorPicker align-end">
    <v-flex flex xs1 pb-4 mr-2>
      <v-icon :style="showColor">lens</v-icon>
    </v-flex>
    <v-flex xs10>
      <v-text-field
        @focus="opened=true"
        v-model="selectedColor"
        :label="label"
        :rules="$store.state.formRules.required"
        required
        :append-icon="opened ? 'done' : 'keyboard_arrow_down'"
        @click:append="opened = opened = !opened"
        readonly
      ></v-text-field>
      <sketch-picker
        class="colorPickerAbsolute"
        v-show="opened"
        @input="updateValue"
        :value="colors"
        :preset-colors="presetColors ? presetColors : []"
      ></sketch-picker>
    </v-flex>
  </v-layout>
</template>

<script>
import { Sketch } from 'vue-color'
export default {
  components: {
    'sketch-picker': Sketch
  },
  props: {
    editVal: String,
    autoClose: Boolean,
    field: String,
    updateColorField: Function,
    presetColors: Array,
    label: String
  },
  watch: {
    editVal (val) {
      this.showColor = `color:${val}`
      this.selectedColor = val
    },
    autoClose (val) {
      if (!val) {
        this.opened = false
        this.selectedColor = ''
        this.showColor = ''
      }
    }
  },
  methods: {
    updateValue (value) {
      this.showColor = `color:${value.hex}`
      this.selectedColor = value.hex
      this.updateColorField(value.hex, this.field)
    }
  },
  data () {
    return {
      showColor: '',
      selectedColor: '',
      opened: false,
      colors: ''
    }
  }
}
</script>

<style>
.colorPickerAbsolute {
  position: fixed !important;
  z-index: 2;
}
.wrappColorPicker {
  position: relative;
}
</style>
